import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { UpdateAccountInformationCommand } from '../../../../core/api/models/update-account-information-command';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { AccountInformationDto } from './../../../../core/api/models/account-information-dto';
import { CreateAccountInformationCommand } from './../../../../core/api/models/create-account-information-command';
import { TypeBanks } from './../../../../core/api/models/type-banks';
import { AccountInformationService } from './../../../../core/api/services/account-information.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-account-information-form',
    templateUrl: './account-information-form.component.html',
    styles: [
        `
      .ir {
        position: absolute;
        left: 30px;
        bottom: -1px;
        transition: right 0.2s;
      }
    `,
    ],
    imports: [BaseFormModule]
})
export class AccountInformationFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  iban;
  formPageConfig: FormPageConfig<AccountInformationDto>;
  model: CreateAccountInformationCommand = {};
  get TypeBanks() {
    return TypeBanks;
  }

  protected currentService = inject(AccountInformationService);

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      //this.model.iban=this.model.iban.replace('IR','');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  //#region init

  initModel(): void {
    try {
      this.model.isActive = false;
      super.initModel();
      if (!this.formPageConfig.isEditMode) this.iban = null;
      else this.iban = this.model.iban.replace('IR', '');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  initForm() {
    this.form = new FormGroup({
      typeBank: new FormControl('', Validators.required),
      accountNo: new FormControl('', [Validators.required]),
      isActive: new FormControl(''),
      branch: new FormControl('', [Validators.required]),
      cardNo: new FormControl('', [Validators.required]),
      iban: new FormControl('', [Validators.required]),
      owner: new FormControl('', [Validators.required]),
    });
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateAccountInformationCommand) {
    this.unSubs();

    this.loading = true;
    model.iban = 'IR' + this.iban;
    this.currentService
      .accountInformationCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateAccountInformationCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;
    model.iban = 'IR' + this.iban;

    this.currentService
      .accountInformationUpdatePut({
        id: this.formPageConfig.editId,
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
    // this.formPageConfig.isEditMode = false;
  }

  //#endregion
}
